<template>
  <div
    ref="listOfSections"
    :class="['additional_dropdown__menu', isLeft ? 'left-position' : '']"
  >
    <b-dropdown-item
      v-for="section in fieldsToRender"
      :key="section.id"
      @click="moveItemToSection(section.id)"
    >
      {{ section.Name }}
    </b-dropdown-item>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import {moveItemToAnotherSection} from '@/store/modules/designer/actions';

const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');
export default {
  name: 'AdditionalDropdownMenu',
  props: {
    containerId: {
      type: String,
      required: true,
    },
    fieldGuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLeft: false,
    };
  },
  computed: {
    ...designerMapState({
      listOfSections: state => state.data.Sections,
    }),
    fieldsToRender() {
      return this.listOfSections.filter(el => el.id !== this.containerId);
    },
  },
  methods: {
    ...designerMapActions(['moveItemToAnotherSection']),
    moveItemToSection(id) {
      this.moveItemToAnotherSection({
        toSectionId: id,
        fromSectionId: this.containerId,
        fieldId: this.fieldGuid,
      });
    },
  },
  mounted() {
    const $sectionContainer = document.getElementById(this.containerId);
    const {left} = this.$refs.listOfSections.getBoundingClientRect();
    const {width} = $sectionContainer.getBoundingClientRect();

    this.isLeft = left > width;
  },
};
</script>


<style scoped lang="scss">
.additional_dropdown__menu {
  padding-block: 4px;
  min-width: 100px;
  width: fit-content;
  box-shadow: 0 0 10px #eee;
  top: 0;
  right: 0;
  transform: translateX(100%);
  position: absolute;
  background-color: #fff;
  border: 1px solid #eee;

  &.left-position {
    left: 0;
    transform: translateX(-100%);
  }
}
</style>